import { Col, Row } from 'antd';
import { AppModal, AppModalProps, LoadingSpin } from '../common';
import { useTranslation } from 'react-i18next';

export interface LogModalProps extends AppModalProps {
  open: boolean;
  data: { title: string; value: any; }[];
  hide: () => void;
  loading?: boolean;
}

const LogModal: React.FC<LogModalProps> = ({
  hide,
  data,
  loading,
  variant,
  ...props
}) => {

  const [t] = useTranslation(['common']);

  return (
    <AppModal
      destroyOnClose
      width="90%"
      title={t('common:labels.activity-details')}
      footer={null}
      onCancel={hide}
      style={{ maxWidth: '850px', maxHeight: '70%' }}
      {...props}
      variant={variant}
    >
      <Row gutter={[0, 16]}>
        {loading ? <LoadingSpin /> :
          Object.keys(data ?? {}).filter(key => data[key]?.title).map((key, i) => (
            <Col key={i} span={12}>
              {data[key]?.title}: {data[key]?.value}
            </Col>
          ))
        }
      </Row>
    </AppModal>
  );
};

export default LogModal;
